import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/amj/fitness_back.webp";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1600 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 1,
  },
  tabletlandscape: {
    breakpoint: { max: 1399, min: 1200 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1199, min: 667 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 666, min: 0 },
    items: 1,
  },
};

function fitness() {
  return (
    <section
      className="fitness p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className=" my-auto">
            <h2>Workplace Wellness Fitness App’s Feature Highlights</h2>
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={3000}
              arrows={true}
              className="carousel_amj"
            >
              <div className="featured_item">
                <p>
                  The app collects data via a form. After receiving and
                  processing the input, the app generates personalized
                  recommendations on sleep habits, drinking water, losing weight
                  and releasing stress.
                </p>
              </div>
              <div className="featured_item">
                <p>
                  App administrators and employees themselves can create daily,
                  weekly, or monthly competitions to achieve fitness goals.
                </p>
              </div>
              <div className="featured_item">
                <p>
                  The app has push notifications that display tips and tricks,
                  statistics and other recommendations for better physical and
                  mental health.
                </p>
              </div>
              <div className="featured_item">
                <p>
                  Workout videos aim at promoting physical exercises, helping
                  employees of all levels (whether already in fitness regimes or
                  not).
                </p>
              </div>
              <div className="featured_item">
                <p>
                  Employees can set reminders and alarms for personal fitness
                  goals. They can be of any magnitude: from not slouching and
                  maintaining a posture, to drinking 8 glasses of water a day
                  and limiting screen time.
                </p>
              </div>
              <div className="featured_item">
                <p>
                  It’s a cross platform app users with Android and iOS, both can
                  experience a gainful engagement and a boost in their
                  productivity.
                </p>
              </div>
            </Carousel>
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="fitness_img">
              <StaticImage
                src="../../../images/case-studies/amj/fitness_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["png"]}
                width={586}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default fitness;
